<template>
  <div class="w-full max-w-[1160px] min-w-[463px] h-100 overflow-auto pt-[36px] px-[32px] flex flex-col mx-auto">

    <!-- Header -->
    <div class="flex flex-col mb-[32px]">
      <div class="flex items-center gap-[8px] mb-[4px]">
        <IconArrowLeft class="cursor-pointer" @click="backBtnActive = true" />
        <span class="text-[#212529] text-[20px] font-[500] leading-[120%]">Добавление нозологии</span>
      </div>

      <div class="text-[#6C757D] text-[16px] font-[400] leading-[150%]">Нозологии</div>
    </div>
    <!-- End Header -->
    <!-- Content -->
    <VSkeleton v-if="isLoading" class="w-full h-[456px] rounded-[8px]"/>
    <div v-else-if="isError" class="flex-1 min-h-0 flex">
        <v-placeholder
          message="Что-то пошло не так"
          description="Попробуйте повторить запрос <br> или обратитесь в службу поддержки"
          :icon="{ name: 'xl/mood-confuzed' }"
          :retry="{ label: 'Повторить запрос', handler: fetchNosologyList }"
          class="!min-h-[70vh] h-full w-full !p-[24px]"
        >
          <template #footer>
            <p class="text-14-reg-400">Позвонить в техподдержку</p>
            <a
              class="text-v-ui-text-main text-14-reg-400 mt-[8px]"
              href="tel:88005000299"
              >8 800 500-02-99</a
            >
          </template>
        </v-placeholder>
      </div>

    <NosologyForm
      v-else
      :diagnoses="diagnoses"
      :backBtnActive="backBtnActive"
      :is-infinite-loading="isInfiniteLoading"
      :is-emit-src-loading="isEmitSrcLoading"
      @loadMoreMkb="loadMoreMkb"
      @getMkbFromSearch="getMkbFromSearch"
      @update:backBtnActive="updateBackBtnActive"
    />
  </div>
</template>

<script>
import NosologyForm from '@/components/Kzs/Nosology/NosologyForm';
import IconArrowLeft from '@/assets/images/icon-left.svg';
import {VSkeleton, VPlaceholder} from '@gostelemed.front/rt-doctis.designsystem';
import mkbMixin from '@/mixins/mkb.mixin';

export default {
  name: 'NosologyAdd',
  components: {
    NosologyForm,
    IconArrowLeft,
    VSkeleton,
    VPlaceholder,
  },
  mixins: [mkbMixin],
  data() {
    return {
      isLoading: true,
      isError: false,
      backBtnActive: false,
    }
  },
  async mounted() {
    try {
      await this.getMkbDiagnoses();
    } catch (error) {
      console.error(error);

      this.isError = true;
    } finally {
      this.isLoading = false;
    }
  },
  methods: {
    updateBackBtnActive(value) {
      this.backBtnActive = value;
    },
  }
}
</script>
